// store.js
import { createStore } from 'vuex';


export default createStore({
    state: {
        caseId: null,
        actualCase: null,
        sessionId: localStorage.getItem('sessionId') || null,
        session: JSON.parse(localStorage.getItem('session')) || null,
        user: JSON.parse(localStorage.getItem('user')) || null,
        course: null,
        frontPage: "",
        showHeader: !!JSON.parse(localStorage.getItem('user')),
        isLoading: false,
        isExternalFrame: sessionStorage.getItem('isExternalFrame') === '1'
  },
  mutations: {
        setLoading(state, payload) {
            state.isLoading = payload;
        },
        setShowHeader(state, payload) {
            state.showHeader = payload;
        },
        setExternalFrame(state, payload) {
            state.isExternalFrame = payload;
            if (payload) {
                sessionStorage.setItem('isExternalFrame', '1');
            } else {
                sessionStorage.removeItem('isExternalFrame');
            }
        },
        setCaseId(state, payload) {
            state.caseId= payload;
        },
        setCase(state, payload){
            state.actualCase = payload;
        },
        setSessionId(state, payload) {
            state.sessionId = payload;
            if (payload) {
                localStorage.setItem('sessionId', payload);
            } else {
                localStorage.removeItem('sessionId');
            }
        },
        setSession(state, payload) {
            state.session = payload;
            if (payload) {
                localStorage.setItem('session', JSON.stringify(payload));
            } else {
                localStorage.removeItem('session');
            }
        },
        setCourse(state, payload) {
            state.course = payload;
        },
        updateUser(state, data) {
            if (data && data.user) {
                state.user = data.user;
                if (data.tokens) {
                    state.user.tokens = data.tokens;
                }
                localStorage.setItem('user', JSON.stringify(state.user));
            } else {
                state.user = data;
                if (data) {
                    localStorage.setItem('user', JSON.stringify(data));
                } else {
                    localStorage.removeItem('user');
                }
            }
        },
        updateTokens(state, tokens) {
            if (state.user) {
                state.user.tokens = tokens;
                localStorage.setItem('user', JSON.stringify(state.user));
            }
        },
        logout(state) {
            state.user = null;
            state.session = null;
            state.sessionId = null;
            state.showHeader = false;
            localStorage.removeItem('user');
            localStorage.removeItem('session');
            localStorage.removeItem('sessionId');
            sessionStorage.removeItem('isExternalFrame');
        },
        updateFrontPage(state, page) {
            state.frontPage = page;
        }
    },
    actions: {
        updateCaseId({ commit }, payload) {
            commit('setCaseId', payload);
        },
        updateCase({ commit }, payload) {
            commit('setCase', payload);
        },
        updateSessionId({ commit }, payload) {
            commit('setSessionId', payload);
        },
        updateSession({ commit }, payload) {
            commit('setSession', payload);
        },
        updateCourse({ commit }, payload) {
            commit('setCourse', payload);
        },
        updateShowHeader({ commit }, payload) {
            commit('setShowHeader', payload);
        },
        updateExternalFrame({ commit }, payload) {
            commit('setExternalFrame', payload);
        },
        updateLoading({ commit }, payload) {
            commit('setLoading', payload);
        },
        logout({ commit }) {
            commit('logout');
        }
    },
    getters: {
        isLoggedIn: state => !!state.user,
        refreshToken: state => state.user?.tokens?.refresh?.token
    }
});
